export * from './admission-result.component';
